var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "29px",
    viewBox: "0 0 29 29",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_avatar") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u5207\\u7247",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u753B\\u677F",
    transform: "translate(-103, -162)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706\\u5F62",
    stroke: "#0E1C39",
    cx: 117.5,
    cy: 176.5,
    r: 13.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.5,165 C123.851275,165 129,170.148725 129,176.5 C129,182.851275 123.851275,188 117.5,188 C111.148725,188 106,182.851275 106,176.5 C106,170.148725 111.148725,165 117.5,165 Z M117.635903,166.596382 C115.438318,166.596382 112.734604,168.088153 113.735997,172.624684 C114.737389,177.161214 115.21404,175.260333 115.21404,178.091705 C115.21404,180.923077 108.99422,180.923077 108.045432,181.497166 C107.096645,182.071255 110.888266,187.726046 117.5,187.726046 C124.111734,187.726046 126.448739,183.619742 127.348379,181.687093 C128.248018,179.754444 120.002891,180.895858 120.002891,178.091705 C120.002891,175.287552 120.852592,177.161214 121.476612,172.624684 C122.123657,167.920771 119.833488,166.596382 117.635903,166.596382 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    stroke: "#0F2649",
    fill: "#0E1C39"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAvatar);
export default __webpack_public_path__ + "static/media/icon_avatar.dd54c6d242c772656baba7e38e828ebe.svg";
export { ForwardRef as ReactComponent };